export const painPoints = [
  {
    emoji: '🧭',
    title: 'You don’t know where to start',
    desc: 'The blank prompt box slows you down. You know the engineering task, but you need a structured way to explain the objective, provide the right context, and define the expected output.',
  },
  {
    emoji: '🔤',
    title: 'You struggle to get the right technical response',
    desc: 'Generic prompts can produce vague explanations, incomplete assumptions, or outputs that need substantial restructuring. You need clearer instructions tailored to electrical engineering applications.',
  },
  {
    emoji: '🧩',
    title: 'You need to review AI-generated results',
    desc: 'AI can make mistakes, omit important variables, or misunderstand technical context. You need a process that helps you identify missing information, examine assumptions, and verify outputs before relying on them.',
  },
  {
    emoji: '🎯',
    title: 'You want to spend less time on repetitive tasks',
    desc: 'Preparing technical reports, organizing calculations, documenting faults, and structuring project information can consume time that could otherwise be spent on engineering analysis and professional responsibilities.',
  },
];
